module.exports = (($) => {
    class Forms {
        static disable() {
            $('.ity .form-control').attr("disabled", true);;
            $('.ity input[type=submit]').attr("disabled", true);;
            $('.ity button[type=submit]').attr("disabled", true);;
        }
        static enable() {
            $('.ity .form-control').removeAttr('disabled');
            $('.ity input[type=submit]').removeAttr('disabled');
            $('.ity button[type=submit]').removeAttr('disabled');
        }
        static showErrors(errors) {
            var fieldSelect;

            $.each(errors, function(fieldName, fieldErrors) {
                fieldSelect = (typeof UI === 'object' && UI.form_selector.length)
                    ? UI.form_selector + ' [name=' + fieldName + ']'
                    : '[name=' + fieldName + ']';
                $(fieldSelect).addClass('is-invalid');
                $(fieldSelect).after('<span class="invalid-feedback">' + fieldErrors.join(', ') + '</span>');
            });
        }
        static hideErrors() {
            $('body').find('.is-invalid').removeClass('is-invalid');
            $('.invalid-feedback').remove();
        }
    }
    $(document).ajaxStart(function() {
        Forms.hideErrors();
        Forms.disable();
    });
    $(document).ajaxStop(function() {
        Forms.enable();
    });
    $(document).ajaxError(function(event, jqxhr, settings, thrownError) {
        // validation errors
        if (jqxhr.status == 422 && jqxhr.responseJSON !== undefined && jqxhr.responseJSON.errors !== undefined) {
            Forms.showErrors(jqxhr.responseJSON.errors);
        }
    });
    $(document).ajaxComplete(function() {
        if (typeof UI === 'object') {
            UI.form_selector = '';
        }
    });
    return Forms
})(jQuery)
